import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import merchantRatesColumns from "./merchantRatesColumns";

type Props = {
  name: string;
  merchantId: number;
};

const query = gql`
  query Currentlist($merchantId: ID!, $offset: Int, $limit: Int) {
    merchant(id: $merchantId) {
      merchant_rates(offset: $offset, limit: $limit) {
        rate
        active_from
        active_to
        dynamic
      }
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ merchantId, pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      merchantId,
      offset,
      limit,
    },
  }),
});

export default withPagination(
  withData((props) => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={merchantRatesColumns}
        defaultColumns={["Active From", "Active To", "Rate", "Dynamic"]}
        rows={(props.data.merchant && props.data.merchant.merchant_rates) || []}
        pagination={props.pagination}
        name={props.name}
      />
    </BOGraphQLLoader>
  ))
);
